module.exports = __webpack_public_path__ + "img/error-connectiion.84e471d3.svg";